<template>
  <div>
    <Header />
    <v-container style="max-width: 100%">

      <v-row v-if="error">
        <v-col cols="12">
          <v-alert type="error">{{ error }}</v-alert>
        </v-col>
      </v-row>

      <!-- Cutoff date cards -->
      <v-row v-if="configLoading">
        <v-col cols="12" class="text-center">
          <v-progress-circular indeterminate color="primary" />
        </v-col>
      </v-row>

      <template v-else>
        <v-row v-for="(event, eventKey) in config" :key="eventKey">
          <v-col cols="12">
            <div class="overline mb-2 pl-1">{{ event.label }}</div>
          </v-col>
          <v-col
            v-for="(cutoff, country) in event.cutoffs"
            :key="country"
            cols="12" sm="6" md="3"
          >
            <v-card
              outlined
              :class="{ 'selected-country': selectedCountry === country }"
              style="cursor: pointer"
              @click="selectCountry(country)"
            >
              <v-card-title class="pb-1">
                <v-icon left>mdi-flag</v-icon>
                {{ country.toUpperCase() }}
              </v-card-title>
              <v-divider />
              <v-list dense>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon small color="orange darken-2">mdi-cart-off</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle>Bestellschluss</v-list-item-subtitle>
                    <v-list-item-title>{{ formatDate(cutoff.orderCutoff) }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon small color="red darken-2">mdi-truck-off</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle>Lieferschluss</v-list-item-subtitle>
                    <v-list-item-title>{{ formatDate(cutoff.deliveryCutoff) }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <!-- Orders section -->
      <template v-if="selectedCountry">
        <v-row class="mt-4">
          <v-col cols="12">
            <div class="overline pl-1">
              Offene Bestellungen — {{ selectedCountry.toUpperCase() }}
              <v-chip small class="ml-2" color="primary">{{ orders.length }}</v-chip>
            </div>
          </v-col>
        </v-row>

        <v-row v-if="ordersLoading">
          <v-col cols="12" class="text-center">
            <v-progress-circular indeterminate color="primary" />
          </v-col>
        </v-row>

        <v-row v-else-if="orders.length === 0">
          <v-col cols="12">
            <v-alert type="success">Keine offenen Bestellungen vor dem Cutoff.</v-alert>
          </v-col>
        </v-row>

        <v-row v-else>
          <v-col
            v-for="order in orders"
            :key="order.orderId"
            cols="12" sm="6" md="4" lg="3"
          >
            <v-card outlined>
              <v-card-text class="pb-2 pt-3">
                <div class="caption grey--text">Bestellnummer</div>
                <div class="subtitle-2">{{ order.orderId }}</div>
                <div class="caption grey--text mt-2">Managed ID</div>
                <div class="subtitle-2">{{ order.managedId || '—' }}</div>
                <div class="caption grey--text mt-2">Bestellt am</div>
                <div>{{ formatDateTime(order.createDate) }}</div>
                <div class="caption grey--text mt-2">Artikel</div>
                <div v-for="(product, i) in order.products" :key="i" class="caption">
                  {{ product.qty }}x {{ product.sku }}
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </template>

    </v-container>
  </div>
</template>

<script>
import Header from '../header'
import CutoffService from '@/services/CutoffService'

export default {
  name: 'CutoffMonitor',
  components: { Header },
  data: () => ({
    config: {},
    configLoading: false,
    selectedCountry: null,
    orders: [],
    ordersLoading: false,
    error: null,
  }),
  async mounted() {
    await this.loadConfig()
  },
  methods: {
    async loadConfig() {
      this.configLoading = true
      this.error = null
      try {
        const response = await CutoffService.getConfig()
        this.config = response.data
      } catch (e) {
        this.error = 'Fehler beim Laden der Cutoff-Konfiguration.'
        console.error(e)
      } finally {
        this.configLoading = false
      }
    },
    async selectCountry(country) {
      this.selectedCountry = country
      this.ordersLoading = true
      this.orders = []
      this.error = null
      try {
        const response = await CutoffService.getOrders(country)
        this.orders = response.data.orders
      } catch (e) {
        this.error = 'Fehler beim Laden der Bestellungen.'
        console.error(e)
      } finally {
        this.ordersLoading = false
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '-'
      const [year, month, day] = dateStr.split('-')
      return `${day}.${month}.${year}`
    },
    formatDateTime(dateStr) {
      if (!dateStr) return '-'
      const d = new Date(dateStr)
      return d.toLocaleDateString('de-DE') + ' ' + d.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })
    }
  }
}
</script>

<style scoped>
.selected-country {
  border-color: var(--v-primary-base) !important;
  border-width: 2px !important;
}
</style>
